import React, { type FunctionComponent } from 'react'
import { FormContextValues } from 'react-hook-form'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'
import { type PlacementTypeEnum } from 'domains/banners/api'
import { BannerType, BannerFormImages } from 'domains/banners/types/banner.types'
import { MerchandisingFormSectionDivider } from 'domains/merchandising/components/form-section/MerchandisingFormSectionDivider'
import {
  BannerFormContentImageInput,
  type Props as ImageInputProps,
} from './BannerFormContentImageInput'

interface Props extends Omit<ControllerProps, 'name'> {
  type: PlacementTypeEnum
}

type bannerOptions = {
  [key in PlacementTypeEnum]?: ImageInputProps[]
}

const imageDefinitionsForType: bannerOptions = {
  HERO_BANNER: [
    {
      identifier: 'images.desktop',
      required: false,
      labelId: 'bannersDomain.bannersForm.form.link-destination.input.image.heroBanner.desktop',
      previewDimensions: { width: 384, height: 48 },
      imageDimensions: { width: 3456, height: 432 }, // this is x3
    },
    {
      identifier: 'images.mobile',
      required: false,
      labelId: 'bannersDomain.bannersForm.form.link-destination.input.image.heroBanner.mobile',
      previewDimensions: { width: 480, height: 260 },
      imageDimensions: { width: 1425, height: 771 },
    },
  ],
  SECONDARY_BANNER: [
    {
      identifier: 'images.desktop',
      required: false,
      labelId:
        'bannersDomain.bannersForm.form.link-destination.input.image.secondaryBanner.desktop',
      previewDimensions: { width: 384, height: 48 },
      imageDimensions: { width: 3456, height: 432 }, // this is x3
    },
    {
      identifier: 'images.mobile',
      required: false,
      labelId: 'bannersDomain.bannersForm.form.link-destination.input.image.secondaryBanner.mobile',
      previewDimensions: { width: 718, height: 180 },
      imageDimensions: { width: 1029, height: 258 },
    },
  ],
  STANDARD_INFORMATION_MODAL: [
    {
      identifier: 'images.desktop',
      required: false,
      labelId: 'bannersDomain.bannersForm.form.link-destination.input.image.flyout.desktop',
      previewDimensions: { width: 512, height: 288 },
      imageDimensions: { width: 1024, height: 576 }, // this is x3
    },
    {
      identifier: 'images.mobile',
      required: false,
      labelId: 'bannersDomain.bannersForm.form.link-destination.input.image.flyout.mobile',
      previewDimensions: { width: 256, height: 144 },
      imageDimensions: { width: 768, height: 432 },
    },
  ],
}

export const BannerFormContentImage: FunctionComponent<Props> = ({ type, form }) => {
  const imageDefinitions = imageDefinitionsForType[type]
  // const { watch, errors, register, control, setValue } = form;
  const { errors, register, getValues } = form

  return (
    <div>
      <MerchandisingFormSectionDivider />
      {imageDefinitions?.map((banner: ImageInputProps) => (
        <React.Fragment key={banner.identifier}>
          <BannerFormContentImageInput
            {...banner}
            defaultUrl={getValues(banner.identifier)}
            ref={register({ required: banner.required })}
            errors={errors}
          />
          <MerchandisingFormSectionDivider />
        </React.Fragment>
      ))}
    </div>
  )
}
